import { baseUrl } from "./baseUrl";

export const API_URLs = {
  authentincation: {
    login: baseUrl + "/Login",
    verify: baseUrl + "/Verification",
    checkLogin: baseUrl + "/CheckLogin",
  },
  home: {
    getDashboardInfo: baseUrl + "/students/dashboard",
  },
  profile: {
    getProfileData: baseUrl + "/storeProfileDetail",
    editProfile: baseUrl + "/EditstoreProfileDetail",
    getStoreAccountStatus: baseUrl + "/StoreAccountStatus",
  },
  pallete: {
    getPalletes: baseUrl + "/storePanel/api/Palet/Palets",
    deletePallete: baseUrl + "/storePanel/api/Palet/DeletePalet",
    editPallete: baseUrl + "/storePanel/api/Palet/EditPrice",
    getMaterials: baseUrl + "/storePanel/api/Palet/Materials",
    createPallete: baseUrl + "/storePanel/api/Palet/CreatePalet",
    getColors: baseUrl + "/storePanel/api/Palet/Colors",
  },
  addProductSteps: {
    getMasterCategories: baseUrl + "/storePanel/api/Products/MasterCategories",
    getSubCategories: baseUrl + "/storePanel/api/Products/SubCategories",
    getSubCategorieFeatures: baseUrl + "/storePanel/api/Products/Features",
    getBrands: baseUrl + "/storePanel/api/Products/Brands",
    createProduct: baseUrl + "/storePanel/api/Products/CreateProduct",
  },
  bargaining: {
    getBargainingsList: baseUrl + "/ProviderBargainingList",
    reviseBargaining: baseUrl + "/ReviseProviderBargaining",
    rejectBargaining: baseUrl + "/RejectedProviderBargaining",
    confirmBargaining: baseUrl + "/ConfirmProviderBargaining",
  },
  products: {
    getVerifiedProducts: baseUrl + "/storePanel/api/Products/ProductList",
    getWaitingForVerfyProducts:
      baseUrl + "/storePanel/api/Products/RequestedProductList",
  },
  productDetails: {
    getVerifiedProductDetails:
      baseUrl + "/storePanel/api/Products/ProductDetail",
    getWaitingProductDetails:
      baseUrl + "/storePanel/api/Products/RequestedProductDetail",
    getVerifiedInventory: baseUrl + "/storePanel/api/Products/Inventory",
    getWaitingInventory:
      baseUrl + "/storePanel/api/Products/RequestedInventory",
    getQuestions: baseUrl + "/storePanel/api/Products/QuestionList",
    getComments: baseUrl + "/storePanel/api/Products/Comments",
    addAndAnswerFaq:
      baseUrl + "/storePanel/api/Products/ProviderCreateQuestion",
    deleteVerifiedProduct: baseUrl + "/storePanel/api/Products/RemoveProduct",
    deleteWaitingProduct:
      baseUrl + "/storePanel/api/Products/RemoveRequestedProduct",
    deleteVerifiedProductSample:
      baseUrl + "/storePanel/api/Products/RemoveProductSeller",
    deleteWaitingProductSample:
      baseUrl + "/storePanel/api/Products/RemoveRequestedProductSeller",
    editProduct: baseUrl + "/storePanel/api/Products/EditProduct",
    addProductEntity: baseUrl + "/storePanel/api/Products/AddProductSeller",
  },
  orders: {
    getOrders: baseUrl + "/Requests",
    seeOrder: baseUrl + "/SeeRequest",
    sendOrder: baseUrl + "/SendRequest",
    finishOrder: baseUrl + "/FinishRequest",
    getOrderDetails: baseUrl + "/Detail",
  },
  B2B: {
    getProducerProducts: baseUrl + "/storePanel/api/B2B/TolidiProducts",
    getProducerProductDetails: baseUrl + "/storePanel/api/B2B/ProductDetail",
    submitOrder: baseUrl + "/storePanel/api/B2B/SubmitCart",
    getOrderPaymentDetails: baseUrl + "/storePanel/api/B2B/Payment",
  },
};
